export default function NoteIcon() {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.4"
        d="M20.9189 8.75V18.5C20.9189 21.5 19.1289 22.5 16.9189 22.5H8.91895C6.70895 22.5 4.91895 21.5 4.91895 18.5V8.75C4.91895 5.5 6.70895 4.75 8.91895 4.75C8.91895 5.37 9.16892 5.93 9.57892 6.34C9.98892 6.75 10.5489 7 11.1689 7H14.6689C15.9089 7 16.9189 5.99 16.9189 4.75C19.1289 4.75 20.9189 5.5 20.9189 8.75Z"
        fill="#91A2BB"
      />
      <path
        d="M16.9189 4.75C16.9189 5.99 15.9089 7 14.6689 7H11.1689C10.5489 7 9.98892 6.75 9.57892 6.34C9.16892 5.93 8.91895 5.37 8.91895 4.75C8.91895 3.51 9.92895 2.5 11.1689 2.5H14.6689C15.2889 2.5 15.849 2.75 16.259 3.16C16.669 3.57 16.9189 4.13 16.9189 4.75Z"
        fill="#91A2BB"
      />
      <path
        d="M12.9189 14.25H8.91895C8.50895 14.25 8.16895 13.91 8.16895 13.5C8.16895 13.09 8.50895 12.75 8.91895 12.75H12.9189C13.3289 12.75 13.6689 13.09 13.6689 13.5C13.6689 13.91 13.3289 14.25 12.9189 14.25Z"
        fill="#91A2BB"
      />
      <path
        d="M16.9189 18.25H8.91895C8.50895 18.25 8.16895 17.91 8.16895 17.5C8.16895 17.09 8.50895 16.75 8.91895 16.75H16.9189C17.3289 16.75 17.6689 17.09 17.6689 17.5C17.6689 17.91 17.3289 18.25 16.9189 18.25Z"
        fill="#91A2BB"
      />
    </svg>
  );
}
